import { render, staticRenderFns } from "./VideoConfirmationModal.vue?vue&type=template&id=1c54de51&scoped=true"
import script from "./VideoConfirmationModal.vue?vue&type=script&lang=js"
export * from "./VideoConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./VideoConfirmationModal.vue?vue&type=style&index=0&id=1c54de51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c54de51",
  null
  
)

export default component.exports